const phase2 = {
  number: 2,
  title: "Building Endurance",
  weeks: "Weeks 5–10",
  dates: "Mar 16 – Apr 26",
  color: "#2E75B6",
  light: "#EEF4FB",
  accent: "#1A5A9A",
  running: "Continuous running — walk breaks fade out",
  hrTarget: "Zone 2: {Z2}",
  watchAlert: "Long run Sundays — no KB beforehand",
  weekData: [
    {
      week: 5,
      label: "Week 5",
      focus: "Walk breaks shrinking. Run 5min / Walk 20s — almost continuous.",
      days: [
        { day: "Mon", type: "rest", note: "Full rest" },
        {
          day: "Tue",
          type: "strength+run",
          workout: "A",
          run: "5min run / 20s walk × 6 (32 min)",
          note: "Nearly continuous — walk breaks are tiny now",
        },
        {
          day: "Wed",
          type: "strength",
          workout: "B",
          note: "Standalone strength — no run. Focus purely on form.",
        },
        {
          day: "Thu",
          type: "strength+run",
          workout: "A",
          run: "5min run / 20s walk × 6 (32 min)",
          note: "Same as Tuesday",
        },
        { day: "Fri", type: "rest", note: "Full rest" },
        {
          day: "Sat",
          type: "strength+run",
          workout: "B",
          run: "Easy continuous 20 min",
          note: "First fully continuous run if HR allows",
        },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 4 km — Zone 2 only",
          note: "No KB today. Run target distance, walk briefly if HR exceeds {Z2_MAX}.",
        },
      ],
    },
    {
      week: 6,
      label: "Week 6",
      focus: "First distance-based long run. 4 km Sunday. Easy Zone 2 throughout.",
      days: [
        { day: "Mon", type: "rest", note: "Full rest" },
        {
          day: "Tue",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 20 min",
          note: "No walk breaks unless HR forces it",
        },
        { day: "Wed", type: "strength", workout: "B", note: "Standalone strength session" },
        {
          day: "Thu",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 25 min",
          note: "5 more minutes than Tuesday",
        },
        { day: "Fri", type: "rest", note: "Full rest" },
        {
          day: "Sat",
          type: "strength+run",
          workout: "B",
          run: "Easy continuous 20 min",
          note: "Keep it easy — long run tomorrow",
        },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 4 km — Zone 2 only",
          note: "Complete 4 km. Walk briefly if HR exceeds {Z2_MAX}, then continue.",
        },
      ],
    },
    {
      week: 7,
      label: "Week 7",
      focus: "5 km long run milestone. No walk breaks on long run.",
      days: [
        { day: "Mon", type: "rest", note: "Full rest" },
        {
          day: "Tue",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 25 min",
          note: "Zone 2. Conversational pace.",
        },
        {
          day: "Wed",
          type: "strength",
          workout: "B",
          note: "Standalone strength. New moves this phase.",
        },
        {
          day: "Thu",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 25 min",
          note: "Same as Tuesday",
        },
        { day: "Fri", type: "rest", note: "Full rest" },
        {
          day: "Sat",
          type: "strength+run",
          workout: "B",
          run: "Easy continuous 25 min",
          note: "Easy legs for Sunday",
        },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 5 km — Zone 2 only",
          note: "5 km! Aim for no walk breaks. If HR climbs, slow pace instead of walking.",
        },
      ],
    },
    {
      week: 8,
      label: "Week 8",
      focus: "Recovery week — reduce all runs by 20%.",
      recovery: true,
      days: [
        { day: "Mon", type: "rest", note: "Full rest" },
        {
          day: "Tue",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 20 min",
          note: "Recovery week — KB sets down to 2",
        },
        { day: "Wed", type: "strength", workout: "B", note: "2 sets only on all exercises" },
        {
          day: "Thu",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 20 min",
          note: "Short and easy",
        },
        { day: "Fri", type: "rest", note: "Full rest" },
        {
          day: "Sat",
          type: "strength+run",
          workout: "B",
          run: "Easy continuous 20 min",
          note: "Lighter effort",
        },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 5 km — Zone 2 only",
          note: "Same distance but easier effort. No pressure.",
        },
      ],
    },
    {
      week: 9,
      label: "Week 9",
      focus: "7 km long run. Fitness visibly improved since week 1.",
      days: [
        { day: "Mon", type: "rest", note: "Full rest" },
        {
          day: "Tue",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 30 min",
          note: "Back to full effort after recovery week",
        },
        { day: "Wed", type: "strength", workout: "B", note: "Standalone strength — push the reps" },
        {
          day: "Thu",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 30 min",
          note: "Same as Tuesday",
        },
        { day: "Fri", type: "rest", note: "Full rest" },
        {
          day: "Sat",
          type: "strength+run",
          workout: "B",
          run: "Easy continuous 25 min",
          note: "Save energy for Sunday long run",
        },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 7 km — Zone 2 only",
          note: "7 km! Over halfway to race distance. Should feel controlled.",
        },
      ],
    },
    {
      week: 10,
      label: "Week 10",
      focus: "Consolidation — repeat week 9. Consistency is the goal.",
      days: [
        { day: "Mon", type: "rest", note: "Full rest" },
        {
          day: "Tue",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 30 min",
          note: "Same as week 9 — feel the improvement",
        },
        {
          day: "Wed",
          type: "strength",
          workout: "B",
          note: "Last Phase 2 standalone strength session.",
        },
        {
          day: "Thu",
          type: "strength+run",
          workout: "A",
          run: "Easy continuous 30 min",
          note: "Final Thursday run of Phase 2",
        },
        { day: "Fri", type: "rest", note: "Full rest" },
        {
          day: "Sat",
          type: "strength+run",
          workout: "B",
          run: "Easy continuous 25 min",
          note: "Last Saturday of Phase 2",
        },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 7 km — Zone 2 only",
          note: "End of Phase 2. You can run 7 km. Phase 3 starts tomorrow.",
        },
      ],
    },
  ],
  workouts: {
    A: {
      name: "Workout A — Glutes & Posterior Chain",
      duration: "~30 min",
      exercises: [
        {
          name: "Hip Thrust (elevated)",
          sets: "3 × 12",
          cue: "Back on sofa/chair. KB on hips. 3-sec hold at top. Protects knees by strengthening around them.",
          muscles: "Glutes",
          isNew: true,
        },
        {
          name: "Romanian Deadlift",
          sets: "3 × 12",
          cue: "2 more reps than Phase 1. Slow the descent — 3 sec down.",
          muscles: "Hamstrings, glutes",
        },
        {
          name: "KB Swing",
          sets: "3 × 15",
          cue: "NEW this phase. Hip hinge — not a squat. Snap hips forward. All power from glutes.",
          muscles: "Glutes, cardio, core",
          isNew: true,
        },
        {
          name: "KB Row",
          sets: "3 × 12 each",
          cue: "Slow the lowering phase — 3 sec down. Builds back strength.",
          muscles: "Upper back, biceps",
        },
        {
          name: "Dead Bug",
          sets: "3 × 10 each",
          cue: "Slower tempo than Phase 1. Full extension. Back stays flat.",
          muscles: "Core stability",
        },
        {
          name: "Farmer Carry",
          sets: "3 × 20 steps each",
          cue: "Add a pause mid-walk. Brace harder. Don't lean.",
          muscles: "Core, grip, posture",
        },
      ],
    },
    B: {
      name: "Workout B — Full Body Stability",
      duration: "~30 min",
      exercises: [
        {
          name: "Goblet Squat (shallow)",
          sets: "3 × 10",
          cue: "NEW. KB at chest. Shallow range — only as low as knees allow. No pain.",
          muscles: "Quads, glutes",
          isNew: true,
        },
        {
          name: "KB Press (standing)",
          sets: "3 × 10 each",
          cue: "Press overhead. Core braced first. Don't arch lower back.",
          muscles: "Shoulders, triceps",
        },
        {
          name: "Single-Leg Deadlift",
          sets: "3 × 10 each",
          cue: "No wall support this phase. Slow and controlled balance.",
          muscles: "Glutes, hamstrings",
        },
        {
          name: "Push-Up",
          sets: "3 × 12",
          cue: "Full push-ups. Elevate feet slightly if too easy.",
          muscles: "Chest, core",
        },
        {
          name: "KB Halo",
          sets: "3 × 8 each dir",
          cue: "Slower tempo. Feel shoulder mobility improving week by week.",
          muscles: "Shoulders, mobility",
        },
        {
          name: "Suitcase Carry",
          sets: "3 × 20 steps each",
          cue: "NEW. Resist sideways pull. Walk as if balancing a book on head.",
          muscles: "Lateral core (obliques)",
          isNew: true,
        },
      ],
    },
  },
  typeConfig: {
    "strength+run": { bg: "#EEF4FB", border: "#2E75B6", label: "KB + Run", dot: "#2E75B6" },
    strength: { bg: "#F0F7FF", border: "#7EB3E0", label: "KB Only", dot: "#7EB3E0" },
    longrun: { bg: "#E8F5E9", border: "#4CAF50", label: "Long Run", dot: "#4CAF50" },
    rest: { bg: "#F5F5F5", border: "#CCCCCC", label: "Rest", dot: "#BBBBBB" },
  },
};

export default phase2;
